<template>
  <v-dialog v-model="open" persistent max-width="490px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block color="primary" dark v-bind="attrs" v-on="on">
        OOO VM
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Voicemail</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-file-input
            v-model="audioFile"
            type="file"
            show-size
            label="Upload the audio file"
            accept="audio/*"
            truncate-length="50"
          ></v-file-input>
          <audio ref="voiceMailRecord" controls>
            <source v-if="user.role_id == 2" :src="apiUrl + user.voice_mail" />
            <source
              v-else-if="user.role_id == 1"
              :src="apiUrl + settings.default_voice_mail"
            />
          </audio>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="() => (open = false)">
          Close
        </v-btn>
        <v-btn color="blue darken-1" text @click="handleVoiceMail">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "VoiceMails",
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_LINK + "/",
      audioFile: null,
      open: false,
    };
  },
  methods: {
    ...mapMutations({
      setVoiceMail: "auth/SET_VOICE_MAIL",
      setDefaultVoiceMail: "settings/SET_DEFAULT_VOICE_MAIL",
    }),
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    handleVoiceMail() {
      let formData = new FormData();
      formData.append("audio", this.audioFile);
      formData.append("user_id", this.user.id);

      this.$axios
        .post("/lead/upload/voice-mail-audio", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (this.user.role_id == 2) {
            this.setVoiceMail(res.data.url);
          } else if (this.user.role_id == 1) {
            this.setDefaultVoiceMail(res.data.url);
          }

          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          this.$refs.voiceMailRecord.load();
        })
        .catch((e) => {
          console.error(e);
          this.showHandlerSnackbar({
            color: e.response.data.status,
            text: e.response.data.message,
            show: true,
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      settings: "settings/settings",
    }),
  },
};
</script>

<style>
</style>